/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Demands_HintInputs */

const cs_clients_demands_hint = /** @type {(inputs: Clients_Demands_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritéria koupě/pronájmu. Financování je u každé poptávky.`)
};

const en_clients_demands_hint = /** @type {(inputs: Clients_Demands_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy/rent search criteria. Financing lives on each demand.`)
};

/**
* | output |
* | --- |
* | "Buy/rent search criteria. Financing lives on each demand." |
*
* @param {Clients_Demands_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_demands_hint = /** @type {((inputs?: Clients_Demands_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Demands_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_demands_hint(inputs)
	return cs_clients_demands_hint(inputs)
});